import { useClientsStore } from '@/store/clients';
import { useUsersStore } from '@/store/users';
import { useOpportunityStatusesStore } from '@/store/opportunityStatuses';

export const opportunitiesOptions = {
    searchClientsAndLeads: async (query = '') => {
    const store = useClientsStore();
    await store.searchClientsAndLeads({ 'filter[name]': query });
    return store.clients_leads;
  },
  searchUsers: async (query = '') => {
    const store = useUsersStore();
    await store.searchUsers({ 'filter[name]': query });
    return store.users_result;
  },
  searchOpportunityStatuses: async (query = '') => {
    const store = useOpportunityStatusesStore();
    await store.searchOpportunityStatuses({ 'filter[description]': query });
    return store.opportunityStatuses_result;
  },
};
